import React, { Component } from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Input,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from 'reactstrap';
import { connect } from "react-redux";
import { Colxx } from '../../components/common/CustomBootstrap';
import { TableChairGenerateMap } from './tablechair';
import STATUS from '../../constants/status';
import classnames from 'classnames';
import { isRorF } from '../../helpers/Roles';
import ListMenu from './ListMenu';
import CategoryMenu from './CategoryMenu';
import IntlMessages from '../../helpers/IntlMessages';

class TableSetting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
            inputValue: '',
            filteredData: [],
            bills: [],
            orders: props.orders,
            tableData: {},
            isInFullScreen: false,

            listsData: [],
            activeIndex: 99,
            loading: false,

            accordion: [],

            orders: [],
            isInputVisible: false,
        };
        this.searchContainerRef = React.createRef();
    }

    componentDidMount() {
        const initialFilteredData = this.filterDataByName(this.props.searchKeyword || "");
        this.setState({ 
            filteredData: initialFilteredData,
            listsData: [],
            activeIndex: 99,
        });

        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    // Hàm này được gọi mỗi khi props hoặc state thay đổi
    componentDidUpdate(prevProps) {
        // QUAN TRỌNG: Chỉ chạy lại logic khi props có liên quan thay đổi
        
        // 1. Nếu từ khóa tìm kiếm thay đổi
        if (prevProps.searchKeyword !== this.props.searchKeyword) {
            this.updateFilteredData(this.props.searchKeyword);
        }

        // 2. Nếu danh sách menu gốc thay đổi (ví dụ: được fetch lại từ API)
        if (prevProps.menus !== this.props.menus) {
            // Lọc lại dữ liệu với danh sách menus mới và keyword hiện tại
            this.updateFilteredData(this.props.searchKeyword);
        }

        // 3. Hành động khi nhấn Enter
        // Nếu bộ đếm thay đổi, có nghĩa là Enter vừa được nhấn ở TopNav
        if (prevProps.enterPressCount !== this.props.enterPressCount) {
            // console.log('Detected Enter press from Redux!');
            this.selectFirstItem();
        }
    }

    // HÀM MỚI: Logic để chọn item đầu tiên
    selectFirstItem = () => {
        const { filteredData } = this.state;

        // Kiểm tra để đảm bảo có kết quả tìm kiếm
        if (filteredData && filteredData.length > 0 && filteredData[0].data && filteredData[0].data.length > 0) {
            const firstItem = filteredData[0].data[0];

            // Gọi hàm xử lý việc chọn item (có thể là thêm vào giỏ hàng, điều hướng,...)
            this.props.onClickImage(firstItem);
        } else {
            console.log('No item to select.');
        }
    }

    removeVietnameseAccent = (str) => {
        // Map of Vietnamese characters with accents to their non-accented counterparts
        const mapAccents = {
            à: 'a',
            á: 'a',
            ả: 'a',
            ã: 'a',
            ạ: 'a',
            ă: 'a',
            ằ: 'a',
            ắ: 'a',
            ẳ: 'a',
            ẵ: 'a',
            ặ: 'a',
            â: 'a',
            ầ: 'a',
            ấ: 'a',
            ẩ: 'a',
            ẫ: 'a',
            ậ: 'a',
            è: 'e',
            é: 'e',
            ẻ: 'e',
            ẽ: 'e',
            ẹ: 'e',
            ê: 'e',
            ề: 'e',
            ế: 'e',
            ể: 'e',
            ễ: 'e',
            ệ: 'e',
            ì: 'i',
            í: 'i',
            ỉ: 'i',
            ĩ: 'i',
            ị: 'i',
            ò: 'o',
            ó: 'o',
            ỏ: 'o',
            õ: 'o',
            ọ: 'o',
            ô: 'o',
            ồ: 'o',
            ố: 'o',
            ổ: 'o',
            ỗ: 'o',
            ộ: 'o',
            ơ: 'o',
            ờ: 'o',
            ớ: 'o',
            ở: 'o',
            ỡ: 'o',
            ợ: 'o',
            ù: 'u',
            ú: 'u',
            ủ: 'u',
            ũ: 'u',
            ụ: 'u',
            ư: 'u',
            ừ: 'u',
            ứ: 'u',
            ử: 'u',
            ữ: 'u',
            ự: 'u',
            ỳ: 'y',
            ý: 'y',
            ỷ: 'y',
            ỹ: 'y',
            ỵ: 'y',
            đ: 'd',
            À: 'A',
            Á: 'A',
            Ả: 'A',
            Ã: 'A',
            Ạ: 'A',
            Ă: 'A',
            Ằ: 'A',
            Ắ: 'A',
            Ẳ: 'A',
            Ẵ: 'A',
            Ặ: 'A',
            Â: 'A',
            Ầ: 'A',
            Ấ: 'A',
            Ẩ: 'A',
            Ẫ: 'A',
            Ậ: 'A',
            È: 'E',
            É: 'E',
            Ẻ: 'E',
            Ẽ: 'E',
            Ẹ: 'E',
            Ê: 'E',
            Ề: 'E',
            Ế: 'E',
            Ể: 'E',
            Ễ: 'E',
            Ệ: 'E',
            Ì: 'I',
            Í: 'I',
            Ỉ: 'I',
            Ĩ: 'I',
            Ị: 'I',
            Ò: 'O',
            Ó: 'O',
            Ỏ: 'O',
            Õ: 'O',
            Ọ: 'O',
            Ô: 'O',
            Ồ: 'O',
            Ố: 'O',
            Ổ: 'O',
            Ỗ: 'O',
            Ộ: 'O',
            Ơ: 'O',
            Ờ: 'O',
            Ớ: 'O',
            Ở: 'O',
            Ỡ: 'O',
            Ợ: 'O',
            Ù: 'U',
            Ú: 'U',
            Ủ: 'U',
            Ũ: 'U',
            Ụ: 'U',
            Ư: 'U',
            Ừ: 'U',
            Ứ: 'U',
            Ử: 'U',
            Ữ: 'U',
            Ự: 'U',
            Ỳ: 'Y',
            Ý: 'Y',
            Ỷ: 'Y',
            Ỹ: 'Y',
            Ỵ: 'Y',
            Đ: 'D',
        };

        // Replace Vietnamese characters with their non-accented counterparts
        return str.replace(
            /[àáảãạăắằẳẵặâầấẩẫậèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵđÀÁẢÃẠĂẮẰẲẴẶÂẦẤẨẪẬÈÉẺẼẸÊỀẾỂỄỆÌÍỈĨỊÒÓỎÕỌÔỒỐỔỖỘƠỜỚỞỠỢÙÚỦŨỤƯỪỨỬỮỰỲÝỶỸỴĐ]/g,
            function (match) {
                return mapAccents[match];
            }
        );
    };

    filterDataByName = (inputValue) => {
        const menus = [...this.props.menus];

        const normalizedInputValue = this.removeVietnameseAccent(inputValue).toLowerCase();
        const lowercasedInputValue = inputValue.toLowerCase(); // Dùng cho barcode và sku không cần bỏ dấu

        const foundItems = menus.reduce((acc, category) => {
            const filteredData = category.data.filter((item) => {
                // Kiểm tra tên sản phẩm (không phân biệt hoa thường, bỏ dấu)
                const itemNameNormalized = item.name
                    ? this.removeVietnameseAccent(item.name).toLowerCase()
                    : "";
                const nameMatch = itemNameNormalized.includes(normalizedInputValue);

                // Kiểm tra barcode (không phân biệt hoa thường)
                // Chuyển barcode thành chuỗi và xử lý null/undefined
                const itemBarcodeString = item.barcode !== null && item.barcode !== undefined
                    ? String(item.barcode).toLowerCase()
                    : "";
                const barcodeMatch = item.barcode !== null && item.barcode !== undefined && itemBarcodeString.includes(lowercasedInputValue);

                // Kiểm tra SKU (không phân biệt hoa thường)
                const itemSkuLowercased = item.sku ? item.sku.toLowerCase() : "";
                const skuMatch = itemSkuLowercased.includes(lowercasedInputValue);

                return nameMatch || barcodeMatch || skuMatch;
            });

            if (filteredData.length > 0) {
                // Giữ lại các thuộc tính khác của category nếu có, chỉ thay thế data
                acc.push({
                    ...category, // Quan trọng: giữ lại id, name và các thuộc tính khác của category
                    data: filteredData,
                });
            }
            return acc;
        }, []);

        return foundItems;
    };

    // onSearchChange = (e) => {
    //     const inputValue = e.target.value;
    //     const filteredData = this.filterDataByName(inputValue);
    //     // console.log('filteredData: ', filteredData)
    //     this.setState({
    //         search: inputValue,
    //         filteredData: filteredData,
    //     });
    // };

    toggleAccordion = (tab) => {
        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => (tab === index ? !x : false));
        this.setState({
            accordion: state,
        });
    };

    renderCategories() {
        const { menus } = this.props;
        return menus.map((categories, index) => {
            return (
                <span
                    onClick={() => {
                        this.onClickCategory(categories.name, index);
                    }}
                    key={categories.id}
                    id={index}
                    className={
                        this.state.activeIndex === index
                            ? 'active-menu nav_items cursor-pointer py-1 px-3'
                            : 'nav_items cursor-pointer py-1 px-3'
                    }
                >
                    {categories.name}
                </span>
            );
        });
    }

    onClickCategory = (name, index) => {
        let listsData = [...this.props.menus];

        if (name === 'all') {
            const removeFirstElement = listsData.shift();
            this.setState((prev) => ({
                ...prev,
                listsData: [],
                activeIndex: 99,
            }));
        } else {
            const listsSort = listsData.find((menu) => menu.name === name);

            const lists = listsSort?.data?.map((d) => d);

            this.setState((prev) => ({
                ...prev,
                listsData: [{ name: name, data: lists }],
                activeIndex: index,
            }));
        }
    };
        
    // Hàm mới, mục đích là cập nhật state dựa trên keyword từ props
    updateFilteredData = (keyword) => {
        const filteredResult = this.filterDataByName(keyword);
        this.setState({
            filteredData: filteredResult,
            listsData: [],
            activeIndex: 99,
        });
    };

    // TẠO MỘT HÀM MỚI ĐỂ XỬ LÝ SỰ KIỆN CLICK
    handleClearSearch = () => {
        // Gọi action đã được map vào props để dispatch
        // với payload là chuỗi rỗng
        this.props.updateSearchKeyword('');
    }

    render() {
        let {
            menus,
            is_loading_data,
            items,
            isLoading,
            orders,
            onActions,
            onUpdateSelectedFloorTable,
            selectedFloorTable,
            floorsActiveId,
            onToggleDetail,
            onClickImage,
            infoTable,
            billDate,
        } = this.props;

        const { searchKeyword } = this.props;

        const {
            listsData,
            activeIndex,
            loading,
            isInputVisible,
            filteredData,
        } = this.state;

        // Nhóm các mục theo floor
        const groupedByFloor = items?.position?.reduce((acc, item) => {
            const floor = item.floor;
            if (!acc[floor]) {
                acc[floor] = [];
            }
            acc[floor].push(item);
            return acc;
        }, {});

        return is_loading_data ? (
            <div className='loading' />
        ) : (
            <Card
                id='table-chairs'
                className={classnames({
                    disable: !isRorF('orders_table'),
                })}
            >
                <CardBody id='remove-padding'>
                    <CardTitle className='position-relative mb-3'>
                        {/* <IntlMessages id='menu.table-setting' /> */}
                        <RenderFloorTable
                            maxFloor={items.maxFloor}
                            selectedFloorTable={selectedFloorTable}
                            onUpdateSelectedFloorTable={
                                onUpdateSelectedFloorTable
                            }
                            floorsActiveId={floorsActiveId}
                        />
                    </CardTitle>
                    {selectedFloorTable === 100 ? (
                        <Colxx
                            xxs='12'
                            className='table__container__wrapper pl-0 pr-0'
                        >
                            <TabContent activeTab={selectedFloorTable}>
                                <TabPane tabId={100}>
                                    {menus.length > 1 ? (
                                        <div className='d-flex'>
                                            <CategoryMenu
                                                activeIndex={activeIndex}
                                                category={this.renderCategories()}
                                                onClickCategory={(name, num) =>
                                                    this.onClickCategory(
                                                        name,
                                                        num
                                                    )
                                                }
                                            />
                                            {/* <div
                                                ref={this.searchContainerRef}
                                                className='search-container'
                                            >
                                                {!isInputVisible && (
                                                    <div
                                                        onClick={
                                                            this.toggleInput
                                                        }
                                                        className='cursor-pointer'
                                                    >
                                                        <i className='iconsminds-magnifi-glass search-icon' />
                                                    </div>
                                                )}
                                                {isInputVisible && (
                                                    <Input
                                                        autoFocus
                                                        className='input-search'
                                                        placeholder='Tìm kiếm...'
                                                        value={search}
                                                        onChange={
                                                            this.onSearchChange
                                                        }
                                                        onKeyPress={(e) =>
                                                            this.onSearchKey(e)
                                                        }
                                                    />
                                                )}
                                            </div> */}
                                        </div>
                                    ) : null}
                                    <ListMenu
                                        menus={
                                            searchKeyword !== '' ? filteredData : menus
                                        }
                                        ordersParent={orders}
                                        listsData={listsData}
                                        loading={loading}
                                        onClickImage={(product) =>
                                            onClickImage(product)
                                        }
                                        onToggleDetail={onToggleDetail}
                                    />
                                </TabPane>
                            </TabContent>
                        </Colxx>
                    ) : items.row && items.col ? (
                        <Colxx xxs='12' className='table__container__wrapper'>
                            <TableChairGenerateMap
                                isLoading={isLoading}
                                data={items}
                                orders={orders.filter(
                                    (order) =>
                                        order.status_id !== STATUS.DESTROY &&
                                        order.status_id !== STATUS.CLOSED &&
                                        order.status_id !== STATUS.PAYMENTED
                                )}
                                onActions={onActions}
                                infoTable={infoTable}
                                billDate={billDate}
                                maxFloor={items.maxFloor}
                                selectedFloorTable={selectedFloorTable}
                                onUpdateSelectedFloorTable={
                                    onUpdateSelectedFloorTable
                                }
                                floorsActiveId={floorsActiveId}
                            />
                        </Colxx>
                    ) : (
                        <p className='d-flex justify-content-center align-items-center h-75'>
                            Đang tải ...
                        </p>
                    )}
                </CardBody>
            </Card>
        );
    }
}

const RenderFloorTable = ({
    onUpdateSelectedFloorTable,
    selectedFloorTable,
    maxFloor,
    floorsActiveId,
}) => {
    // console.log('maxFloor: ', maxFloor);
    return !maxFloor ? (
        <Nav tabs className='w-100'>
            <NavItem>
                <NavLink
                    href='#'
                    className={classnames('', {
                        active: selectedFloorTable === 100,
                        'floor-has-order': floorsActiveId?.includes(100),
                    })}
                >
                    Menu
                </NavLink>
            </NavItem>
        </Nav>
    ) : (
        <div className='w-100 floor'>
            <Nav tabs className='w-100'>
                {maxFloor >= 1 ? (
                    <div className='d-flex justify-content-between w-100'>
                        <div className='d-flex'>
                            {/* <NavItem
                                onClick={(e) => {
                                    e.preventDefault();
                                    onUpdateSelectedFloorTable(1000);
                                }}
                            >
                                <NavLink
                                    href='#'
                                    className={classnames('', {
                                        active: selectedFloorTable === 1000,
                                        'floor-has-order':
                                            floorsActiveId.includes(1000),
                                    })}
                                >
                                    Tất cả
                                </NavLink>
                            </NavItem> */}
                            {[...new Array(maxFloor).keys()].map((floor) => (
                                <NavItem
                                    key={floor}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onUpdateSelectedFloorTable(floor + 1);
                                    }}
                                >
                                    <NavLink
                                        href='#'
                                        className={classnames('', {
                                            active:
                                                selectedFloorTable ===
                                                floor + 1,
                                            'floor-has-order':
                                                floorsActiveId.includes(
                                                    floor + 1
                                                ),
                                        })}
                                    >
                                        <IntlMessages id='dashboards.area' />{' '}
                                        {floor + 1}
                                    </NavLink>
                                </NavItem>
                            ))}
                        </div>
                        <NavItem
                            onClick={(e) => {
                                e.preventDefault();
                                onUpdateSelectedFloorTable(100);
                            }}
                        >
                            <NavLink
                                href='#'
                                className={classnames('', {
                                    active: selectedFloorTable === 100,
                                    'floor-has-order':
                                        floorsActiveId.includes(100),
                                })}
                            >
                                Menu
                            </NavLink>
                        </NavItem>{' '}
                    </div>
                ) : null}
            </Nav>
        </div>
    );
};

// Lấy state từ Redux store và map vào props của component
const mapStateToProps = ({ searchInput }) => {
    const { keyword } = searchInput;
    return { 
        searchKeyword: keyword, 
        enterPressCount: searchInput.enterPressCount, 
    }; // Map state.search.keyword vào props.searchKeyword
};

export default connect(mapStateToProps)(TableSetting);
